import React from 'react';
import styled from 'styled-components';

import { images } from '@ui/Gallery.tsx';

const Wrapper = styled.div`
  margin: 12px 0;
  display: flex;

  & > div {
    width: 100%;
    overflow: hidden;
    position: relative;
    height: 197px;
    border-radius: 2px;
  }

  .controller {
    background: var(--color-mapNavBackground-85);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);

    :hover {
      background: var(--color-mapNavBackground);
    }

    .icon {
      width: 24px;
      height: 24px;
      fill: var(--color-mapNavText);
      margin: 4px;
    }

    &.left {
      inset-inline-start: 8px;
    }

    &.right {
      inset-inline-end: 8px;
    }
  }

  .number-indicator {
    display: block;

    background: var(--color-mapNavBackground-85);
    fill: var(--color-mapNavText);

    color: var(--color-mapNavText);
  }
`;

const formatImagesToFullImages = images => images.map(url => ({ url }));

const PoiImages = ({ poi, T }) => {
  if (poi?.fullImages?.length) {
    return <Wrapper>{images(poi.fullImages, T, poi.name)}</Wrapper>;
  }
  if (poi?.images?.length) {
    return <Wrapper>{images(formatImagesToFullImages(poi.images), T, poi.name)}</Wrapper>;
  }
  return null;
};

export default PoiImages;
